import React, {useEffect, useState} from 'react';
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

import css from "./HistoryOrderModal.module.css";
import {ordersService} from "../../../../services/orders-services";

const HistoryOrderModal = ({setIsShowHistoryModal, id}) => {
    const {t, i18n} = useTranslation();
    const [history, setHistory] = useState({});

    const currentLanguage = i18n.language || 'en';
    const currentName = history?.packName?.[currentLanguage];

    const closeModalHistoryOrder = () => {
        setIsShowHistoryModal(false);
    };

    useEffect(() => {
        const fetchOrderHistory = async () => {
            try {
                const response = await ordersService.getHistoryOrderById(id);
                setHistory(response);
            } catch (error) {
                console.error(t('modal-toast-creating-error'), error);
                toast.error(t('modal-toast-creating-error'));
            }
        };

        fetchOrderHistory();
    }, [id]);

    return (
        <div className={css.overlay}>
            <div className={css.modal}>
                <div className={css.header}>
                    <div className={css.title}>{t('order')}</div>
                    <div className={css.closeButton} onClick={closeModalHistoryOrder}>&times;</div>
                </div>

                <div className={css.container}>
                    <div className={css.menuSection}>
                        <div className={css.menuSectionHeader}>
                            <div className={css.menu}>{t('menu-menu-title-menu')}</div>
                            <div className={css.dates}>{t('days')}</div>
                        </div>

                        <div className={css.menuSectionInfo}>
                            <div className={css.menu}>{currentName || t('no-name')}</div>

                            <div className={css.dates}>
                                {Array.isArray(history?.dates) && history.dates.length > 0 ? (
                                    history.dates.map((date, index) => (
                                        <div key={index} className={css.singleDate}>
                                            {date}
                                        </div>
                                    ))
                                ) : (
                                    <div className={css.empty}>{t('no-history-found')}</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export {HistoryOrderModal};
